import { Dialog } from "primereact/dialog";

import { rotuloConfianca } from "../shared";

export default function ConfiancaDialog({
    detalhe,
    metodologia,
    onHide,
}) {
    return (
        <Dialog
            header="Como a confiança é calculada"
            onHide={onHide}
            style={{ width: 'min(640px, 95vw)' }}
            visible={Boolean(detalhe)}
        >
            {detalhe && (
                <div style={{ color: '#37474f', lineHeight: 1.5 }}>
                    <p style={{ marginTop: 0 }}>
                        A confiança indica a consistência da base histórica usada para estimar a metragem média dos rolos deste artigo.
                        Ela não representa a situação de abastecimento.
                    </p>

                    <div style={{
                        backgroundColor: '#f5f7f8',
                        border: '1px solid #dfe6e9',
                        borderRadius: 4,
                        marginBottom: 12,
                        padding: 12,
                    }}>
                        <div><strong>Artigo:</strong> {detalhe.cod_artigo}</div>
                        <div><strong>Classificação:</strong> {rotuloConfianca(detalhe.confianca)}</div>
                        <div><strong>Roladas encontradas:</strong> {detalhe.quantidade_roladas_historico}</div>
                        <div><strong>Período analisado:</strong> últimos {metodologia?.historico_meses || 12} meses</div>
                    </div>

                    <p>
                        O histórico vem dos rolos já finalizados no SPI para o mesmo artigo, agrupados por rolada.
                        São considerados registros com rolada preenchida, metragem maior que zero e data de fim dentro do período analisado.
                    </p>

                    <div style={{ fontWeight: 700, marginBottom: 6 }}>Critérios atuais</div>
                    <ul style={{ marginTop: 0, paddingLeft: 20 }}>
                        {Object.entries(metodologia?.classificacao_confianca || {}).map(([chave, descricao]) => (
                            <li key={chave}>
                                <strong>{rotuloConfianca(chave)}:</strong> {descricao}
                            </li>
                        ))}
                    </ul>
                </div>
            )}
        </Dialog>
    );
}
